"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$http = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var $http = exports.$http = _http.$http;